// Convert the emoji model from EmojiMart into a reaction model
import { getMemberId } from '@trello/authentication';
import type { EmojiMartEmoji } from '@trello/emoji';

import type { ReactionModel } from './Reactions.types';

export const createReaction = (
  emoji: EmojiMartEmoji,
  idAction: string,
  idMember?: string,
): ReactionModel => {
  const memberId = getMemberId();
  return {
    id: '',
    idEmoji: emoji.unified.toUpperCase(),
    idMember: idMember || memberId || '',
    idModel: idAction,
    member: {
      id: idMember || memberId || '',
    },
    emoji,
  };
};
